document.addEventListener('DOMContentLoaded', function () {
    const input = document.getElementById('BlogSearchInput');
    if (!input) return;

    const cards = Array.from(document.querySelectorAll('[data-blog-card]'));
    if (!cards.length) return;

    const normalize = (s) => (s || '').toLowerCase().trim();

    input.addEventListener('input', function () {
        const q = normalize(input.value);

        cards.forEach((card) => {
            if (!q) {
                card.style.display = '';
                return;
            }

            const haystack =
                (card.dataset.title || '') + ' ' +
                (card.dataset.tags || '') + ' ' +
                (card.dataset.excerpt || '');

            card.style.display = haystack.includes(q) ? '' : 'none';
        });
    });
});